export default __webpack_public_path__ + "static/hero-test-6ece07d82e68205fa5f97b5f8eb81a38.png";